import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { ResultContext } from '../../contexts/ResultContext';
import { useTheme } from '../../contexts/ThemeContext';

const ColumnTypePieChart = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const axisColor = isDark ? '#ccc' : '#333';

    const { result } = useContext(ResultContext);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const url = result?.results?.visualization_data_jsons['2_column_type_distribution'];
        if (!url) return;

        const fetchData = async () => {
            try {
                const response = await fetch(url);
                if (!response.ok) throw new Error('Failed to fetch file');
                const json = await response.json();
                setData(json);
            } catch (error) {
                console.error('Error loading pie chart data:', error);
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [result]);

    if (loading || !Array.isArray(data)) {
        return <div>Loading chart...</div>;
    }

    const total = data.reduce((sum, item) => sum + item.Count, 0);

    const option = {
        title: {
            text: `Total\n${total}`,
            left: 'center',
            top: 'middle', // keeps it centered in the donut hole
            textStyle: {
                fontSize: 16,
                fontWeight: 'bold',
                align: 'center',
                color: axisColor
            },
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            orient: 'horizontal',
            top: 'top',
            left: 'center',
            textStyle: { color: axisColor },
        },
        series: [
            {
                name: 'Column Types',
                type: 'pie',
                radius: ['40%', '70%'], // Donut style
                center: ['50%', '65%'],
                data: data.map(item => ({
                    name: item.Column_Type,
                    value: item.Count,
                })),
                label: {
                    show: true,
                    position: 'outside',
                    formatter: '{b}: {d}%', // Show label and percentage
                    textStyle: { color: axisColor },
                },
                labelLine: {
                    show: true,
                },
                itemStyle: {
                    borderRadius: 6,
                    borderColor: '#fff',
                    borderWidth: 2,
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 shadow mt-10">
            <ReactECharts option={option} style={{ height: 500, width: '100%' }} />
        </div>
    );
};

export default ColumnTypePieChart;
